export default __webpack_public_path__ + "locales/pt/Ldap.json?hash=0f0595e94b7d6956f734bfcc4968e650";